export function useLeadTracking() {
    const route = useRoute();

    function readQueryParam(name: string) {
        return route.query[name]?.toString() || null;
    };

    function capture() {
        if (!import.meta.client) return;

        const existing = getTrackingData();
        const incoming = {
            gad_campaignid: readQueryParam('gad_campaignid'),
            gad_source: readQueryParam('gad_source'),
            gclid: readQueryParam('gclid'),
            wbraid: readQueryParam('wbraid'),
            gbraid: readQueryParam('gbraid'),
            utm_source: readQueryParam('utm_source'),
            utm_medium: readQueryParam('utm_medium'),
            utm_campaign: readQueryParam('utm_campaign'),
            utm_term: readQueryParam('utm_term'),
            utm_content: readQueryParam('utm_content'),
            landing_page: route.path,
            referrer: document.referrer || null,
            first_touch_ts: existing?.first_touch_ts || new Date().toISOString()
        };
        const hasNewAttribution = incoming.gclid || incoming.utm_source;

        if (!existing && hasNewAttribution)
            setTrackingData(incoming);

        if (existing && hasNewAttribution && incoming.gclid)
            setTrackingData({
                ...existing,
                ...incoming,
                last_touch_ts: new Date().toISOString()
            });
    };

    return { capture };
};